import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
            FAQ
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            H&auml;ufig gestellte Fragen
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            Alles Wissenswerte &uuml;ber das OOPBUY Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 text-foreground-400 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-500 mb-4">
            Noch Fragen? Lesen Sie unseren ausf&uuml;hrlichen Guide.
          </p>
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            Zum vollst&auml;ndigen Leitfaden
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}